<template>
  <v-app
    :class="{ login: $route.name == 'login' || $route.name == 'nigol' || $route.name == 'allbots' }"
  >
    <v-style>
      :root { --primary-color: {{ $vuetify.theme.primary }}; --bg-login:
      {{
        $vuetify.theme.primary == '#FF706B'
          ? '#ff6868, #ffd8a4'
          : `${$vuetify.theme.primary}, ${shadeColor($vuetify.theme.primary, 0)}`
      }}
      }
    </v-style>
    <router-view></router-view>

    <loading></loading>
  </v-app>
</template>

<script>
import loading from '@/components/elements/loading'
import Swal from 'vue-sweetalert2'

import { mapGetters } from 'vuex'

export default {
  name: 'app',
  components: {
    loading,
  },
  created() {
    // this.checkTokenStatus()
  },
  computed: {
    ...mapGetters(['currentLang', 'isFacebook']),
  },
  methods: {
    shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16)
      var G = parseInt(color.substring(3, 5), 16)
      var B = parseInt(color.substring(5, 7), 16)

      R = parseInt((R * (100 + percent)) / 100)
      G = parseInt((G * (100 + percent)) / 100)
      B = parseInt((B * (100 + percent)) / 100)

      R = R < 255 ? R : 255
      G = G < 255 ? G : 255
      B = B < 255 ? B : 255

      var RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16)
      var GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16)
      var BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16)

      return '#' + RR + GG + BB
    },
  },
  watch: {
    $route(to, from) {
      // this.checkTokenStatus()
    },
  },
}
</script>

<style lang="scss">
@import './assets/css/app.scss';
</style>

<style lang="scss">
#app {
  &.login.application {
    background-image: linear-gradient(to top right, var(--bg-login)) !important;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &.application {
    background: white;
  }
}
@font-face {
  font-family: 'rsu';
  src: url('./fonts/RSU_BOLD.ttf');
  /* IE9 Compat Modes */
  src: url('./fonts/RSU_BOLD.ttf?#iefix') format('embedded-opentype'),
    /* IE6-IE8 */ url('./fonts/RSU_BOLD.ttf') format('woff'),
    /* Modern Browsers */ url('./fonts/RSU_BOLD.ttf') format('truetype');
  /* Safari, Android, iOS */
  font-weight: 600;
}
.rsu {
  font-family: 'Sukhumvit' !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue